<script>
    import {createEventDispatcher} from "svelte";
    import {fade, fly} from 'svelte/transition';
    import {album} from "./photo-store";
    const dispatch = createEventDispatcher();
    
    export let photo;

    function close() {
        dispatch('cancel')
    }

    function changePhoto(where) {
        if (where === 'forward' || where.keyCode === 39) {
            photo = album.next(photo);
        } else if (where === 'back' || where.keyCode === 37) {
            photo = album.previous(photo);
        } else if (where.keyCode === 27) {
            close();
        }
    }

    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);

    let xDown = null;
    let yDown = null;

    function getTouches(evt) {
        return evt.touches;
    }

    function handleTouchStart(evt) {
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    }

    function handleTouchMove(evt) {
        if ( ! xDown || ! yDown ) {
            return;
        }
        let xUp = evt.touches[0].clientX;
        let yUp = evt.touches[0].clientY;
        let xDiff = xDown - xUp;
        let yDiff = yDown - yUp;

        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
            if ( xDiff > 0 ) {
                changePhoto('back');
            } else {
                changePhoto('forward');
            }
        }
        xDown = null;
        yDown = null;
    }
</script>
<!--------------------------------------------------------------------------------------------------------------------->
<svelte:window on:keydown={changePhoto}/>

<div class="modal-backdrop" on:click={close} transition:fade></div>

<div class="modal" transition:fly={{y: 300}}>
    <div class="sides left" on:click={() => {changePhoto('back')}}>
        <i class="fa fa-chevron-left fa-2x"></i>
    </div>

    <figure>
        <img src={photo.src} alt={photo.alt}>
        <figcaption class="caption">{photo.alt}</figcaption>
    </figure>

    <div class="sides right" on:click={() => {changePhoto('forward')}}>
        <i class="fa fa-chevron-right fa-2x"></i>
    </div>
</div>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        /*background: rgba(0, 0, 0, 0.80);*/
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(3px);
        z-index: 10;
    }

    .modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*background-color: black;*/
        z-index: 100;

        display: flex;
        align-items: stretch;
    }

    img {
        display: block;
        max-width: 965px;
        height: auto;
        margin: 0 auto;
        /*border-radius: 5px;*/
        /*box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);*/
        border: 1px solid #b0b0b0;
        border-radius: 6px;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
    }

    .sides {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 100px;
    }

    .left {
        justify-content: flex-start;
    }

    .right {
        justify-content: flex-end;
    }

    .fa {
        /*color: gray;*/
        color: #d7d7dc;

    }

    .sides:hover .fa {
        /*color: #d2d2d8;*/
        color: gray;
    }

    .caption {
        margin-top: .9rem;
        text-align: center;
    }

    @media screen and (max-width: 500px) {
        img {
            max-width: 100vw;
            height: auto;
            border: unset;
            box-shadow: unset;
            border-radius: 4px;
        }
        .sides, .right, .left {
            display: none;
        }
        .caption {
            color: #d2d2d8;
        }
        .modal-backdrop {
            background: rgba(0, 0, 0, .86);
            filter: grayscale(100%);
            -webkit-filter: grayscale(100%);
        }
    }

    @media screen and (min-width: 501px) and (max-width: 1000px) {
        img {
            max-width: 100vw;
            height: auto;
        }
    }

</style>
